import { styled } from "@linaria/react";
import React from "react";
import { color, fonts, zIndex } from "..";
import useEnsuredForwardedRef from "../lib/hooks/useEnsuredForwardedRef";
import useHeaderHeight, {
  BANNER_HEIGHT_CSS_VARIABLE,
  PRIMARY_HEADER_HEIGHT_CSS_VARIABLE,
  SECONDARY_HEADER_HEIGHT_CSS_VARIABLE,
} from "./useHeaderHeight";

interface P {
  id?: string;
  nav?: React.ReactNode;
  breadcrumb?: React.ReactNode;
  rightSection?: React.ReactNode;
  className?: string;
}

const Breadcrumb = styled.div`
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  color: ${color.carbon800};
  min-height: 34px;
`;

const Wrapper = styled.div`
  @media screen {
    position: sticky;
    top: calc(var(${PRIMARY_HEADER_HEIGHT_CSS_VARIABLE}) + var(${BANNER_HEIGHT_CSS_VARIABLE}, 0px));
  }

  @media print {
    display: none;
  }

  z-index: ${zIndex.fixedSubheader};
  border-bottom: 1px solid;
  border-bottom-color: ${color.titanium200};
  height: 100%;
  width: 100%;
  display: flex;
  color: ${color.carbon900};
  background-color: ${color.hydrogen};
  padding: 0 15px;
  white-space: nowrap;
  flex-direction: column;
  font: ${fonts.body1SemiBold};
  ${Breadcrumb} {
    margin-right: 10px;
  }
  flex-wrap: wrap;
`;

const TopSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const RightSection = styled.div`
  display: flex;
  padding-right: 20px;
  color: ${color.carbon800};
  min-height: 34px;
  @media (min-width: 620px) {
    margin-left: auto;
  }
`;
const BottomSection = styled.section`
  min-height: 34px;
  width: fit-content;
`;

const SecondaryHeader = (
  { nav, breadcrumb, rightSection, id, className }: P,
  forwardedRef: React.Ref<HTMLDivElement>,
) => {
  const secondaryHeaderRef = useEnsuredForwardedRef(forwardedRef);

  useHeaderHeight(secondaryHeaderRef, SECONDARY_HEADER_HEIGHT_CSS_VARIABLE);

  return (
    <Wrapper ref={secondaryHeaderRef} id={id} className={className}>
      <TopSection>
        {breadcrumb && <Breadcrumb>{breadcrumb}</Breadcrumb>}
        {rightSection && <RightSection>{rightSection}</RightSection>}
      </TopSection>
      {nav && <BottomSection>{nav}</BottomSection>}
    </Wrapper>
  );
};

export default React.forwardRef(SecondaryHeader);
